@if (mediaTypeSignal() === 'pdf' && itemSignal()) {
  <div class="w-100 h-100 d-flex flex-column document-container">
    @if (!isLoadingOrBeingTranscodedSignal() && !commentOnlySignal()) {
      <!-- Simple PDF (no pages or using fallback) -->
      @if (!itemSignal()?.hasPage || !enablePage || useFallbackDisplaySignal()) {
        <div class="d-flex flex-column flex-fill min-h-0">
          <iframe
            [src]="itemSignal()?.previewSRC | safe"
            class="w-100 pdf-file-frame-container flex-fill min-h-0"
            [class.release-pdf-preview]="isReleasePreviewSignal()"
            title="PDF preview">
          </iframe>
          @if (enableAnnotationSignal()) {
            <mtm-comment-annotation
              class="w-100 flex-shrink-0"
              [annotations]="annotationsSignal()"
              [item]="itemSignal()"
              [participants]="projectParticipantsSignal()"
              [hideAnnotationToolbar]="hideAnnotationToolbarSignal()"
              [projectId]="projectIdSignal()"
              [sectionId]="sectionIdSignal()"
              [subsectionId]="subsectionIdSignal()"
              [typeId]="typeIdSignal()"
              [instanceId]="instanceId">
            </mtm-comment-annotation>
          }

          <ng-container [ngTemplateOutlet]="assetListTemplate"></ng-container>
          <ng-container [ngTemplateOutlet]="assetInfoTemplate"></ng-container>
        </div>
      }

      <!-- PDF with pages + annotation -->
      @if (itemSignal()?.hasPage && enablePage && !useFallbackDisplaySignal()) {
        @if (fileTranscodingStatusSignal() === FileTranscodingStatus.IN_PROGRESS) {
          <div class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center pdf-loader">
            <span class="d-inline-block mb-2">
              <mtm-loading-spinner [size]="24"></mtm-loading-spinner>
            </span>
            <span class="heading-text">{{ 'mediaPlayer_transcoding_inProgress' | translate }}</span>
          </div>
        }

        @if (fileTranscodingStatusSignal() === FileTranscodingStatus.SUCCESS) {
          <div class="position-relative document-container">
            @if (itemSignal()?.hasPage) {
              <div
                class="w-100 pdf-file-frame-container d-flex has-page-container"
                [class.release-pdf-preview]="isReleasePreviewSignal()">
                @if (activePageSignal() && annotationsLoadedSignal()) {
                  <div class="pdf-annotation-preview flex-fill">
                    <mtm-image-annotation
                      class="w-100 h-100"
                      [projectId]="projectIdSignal()"
                      [sectionId]="sectionIdSignal()"
                      [subsectionId]="subsectionIdSignal()"
                      [typeId]="itemSignal()?.id"
                      [item]="activePageSignal()"
                      [hideAnnotationToolbar]="hideAnnotationToolbarSignal()"
                      [projectParticipants]="projectParticipantsSignal()"
                      [annotations]="annotationsSignal()"
                      [authUser]="userInfoSignal()"
                      [hasEditPermission]="hasEditPermissionSignal()"
                      [assetListTemplate]="assetListTemplate"
                      [assetInfoTemplate]="assetInfoTemplate"
                      [reviewLink]="subsectionStateSignal()?.reviewLink || null"
                      [instanceId]="instanceId"
                      [file]="itemSignal()">
                    </mtm-image-annotation>
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    }

    @if (isLoadingOrBeingTranscodedSignal() && !commentOnlySignal()) {
      <div
        class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center processing-container">
        <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
          <span>{{ 'asset_processingFile' | translate }}</span>
          <span>{{ 'asset_pleaseWait' | translate }}</span>
        </div>
      </div>
    }

    @if (commentOnlySignal()) {
      <mtm-comment-annotation
        class=""
        [annotations]="annotationsSignal()"
        [item]="itemSignal()"
        [participants]="projectParticipantsSignal()"
        [hideAnnotationToolbar]="hideAnnotationToolbarSignal()"
        [instanceId]="instanceId">
      </mtm-comment-annotation>
    }
  </div>
}
@if (mediaTypeSignal() === 'officeDoc' && itemSignal() && !commentOnlySignal()) {
  <div class="w-100 h-100 min-h-250 d-flex flex-column doc-preview">
    @if (fileTranscodingStatusSignal() === FileTranscodingStatus.IN_PROGRESS || isLoadingSignal()) {
      <div class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center office-loader">
        <span class="d-inline-block mb-2">
          <mtm-loading-spinner [size]="24"></mtm-loading-spinner>
        </span>
        @if (fileTranscodingStatusSignal() === FileTranscodingStatus.IN_PROGRESS) {
          <span class="heading-text">{{ 'mediaPlayer_transcoding_inProgress' | translate }}</span>
        }
        @if (isLoadingSignal()) {
          <span class="heading-text">{{ 'loading' | translate }}</span>
        }
      </div>
    }
    @if (fileTranscodingStatusSignal() === FileTranscodingStatus.FAILED && !isLoadingSignal()) {
      <div class="w-100 h-100 min-h-250 d-flex flex-column office-failed">
        <mtm-pdf-transcode-error [file]="itemSignal()" [transcodingType]="TranscodingTypes.Pdf">
        </mtm-pdf-transcode-error>
      </div>
    }

    @if (fileTranscodingStatusSignal() === FileTranscodingStatus.SUCCESS) {
      <div class="position-relative document-container d-flex flex-column flex-fill min-h-0">
        @if (!itemSignal()?.hasPage) {
          <div class="d-flex flex-column flex-fill min-h-0 w-100">
            <iframe
              [src]="itemSignal()?.previewSRC | safe"
              class="w-100 pdf-file-frame-container flex-fill min-h-0"
              [class.release-pdf-preview]="isReleasePreviewSignal()"
              title="Office document preview">
            </iframe>
            @if (enableAnnotationSignal()) {
              <mtm-comment-annotation
                class="w-100 flex-shrink-0"
                [annotations]="annotationsSignal()"
                [item]="itemSignal()"
                [participants]="projectParticipantsSignal()"
                [hideAnnotationToolbar]="hideAnnotationToolbarSignal()"
                [projectId]="projectIdSignal()"
                [sectionId]="sectionIdSignal()"
                [subsectionId]="subsectionIdSignal()"
                [typeId]="typeIdSignal()"
                [instanceId]="instanceId">
              </mtm-comment-annotation>
            }
          </div>
        }

        @if (itemSignal()?.hasPage) {
          <div
            class="w-100 pdf-file-frame-container d-flex has-page-container"
            [class.release-pdf-preview]="isReleasePreviewSignal()">
            @if (activePageSignal()) {
              <div class="pdf-annotation-preview flex-fill">
                <mtm-image-annotation
                  class="w-100 h-100"
                  [projectId]="projectIdSignal()"
                  [sectionId]="sectionIdSignal()"
                  [subsectionId]="subsectionIdSignal()"
                  [typeId]="itemSignal()?.id"
                  [item]="activePageSignal()"
                  [hideAnnotationToolbar]="hideAnnotationToolbarSignal()"
                  [projectParticipants]="projectParticipantsSignal()"
                  [annotations]="annotationsSignal()"
                  [authUser]="userInfoSignal()"
                  [hasEditPermission]="hasEditPermissionSignal()"
                  [assetListTemplate]="assetListTemplate"
                  [assetInfoTemplate]="assetInfoTemplate"
                  [reviewLink]="subsectionStateSignal()?.reviewLink || null"
                  [instanceId]="instanceId"
                  [file]="itemSignal()">
                </mtm-image-annotation>
              </div>
            }
          </div>
        }

        <ng-container [ngTemplateOutlet]="assetListTemplate"></ng-container>
        <ng-container [ngTemplateOutlet]="assetInfoTemplate"></ng-container>
      </div>
    }
  </div>
}

@if (mediaTypeSignal() === 'powerpoint' && itemSignal() && !commentOnlySignal()) {
  <div class="w-100 h-100 min-h-250 d-flex flex-column doc-preview">
    @if (fileTranscodingStatusSignal() === FileTranscodingStatus.FAILED && !isLoadingSignal()) {
      <div class="w-100 h-100 min-h-250 d-flex flex-column office-failed">
        <mtm-pdf-transcode-error [file]="itemSignal()" [transcodingType]="TranscodingTypes.Pdf">
        </mtm-pdf-transcode-error>
      </div>
    }

    @if (
      (!itemSignal()?.hasPage || !enablePage || useFallbackDisplaySignal()) &&
      fileTranscodingStatusSignal() === FileTranscodingStatus.SUCCESS
    ) {
      <div class="d-flex flex-column document-container">
        <iframe
          [src]="itemSignal()?.previewSRC | safe"
          class="w-100 pdf-file-frame-container"
          [class.release-pdf-preview]="isReleasePreviewSignal()"
          title="PowerPoint preview">
        </iframe>
      </div>
    }

    @if (isLoadingSignal() || fileTranscodingStatusSignal() === FileTranscodingStatus.IN_PROGRESS) {
      <div
        class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center processing-container">
        <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
          <span>{{ 'asset_processingFile' | translate }}</span>
          <span>{{ 'asset_pleaseWait' | translate }}</span>
        </div>
      </div>
    }
  </div>
}
